module.exports = __webpack_public_path__ + "media/images/products-img-05-d40f53364ff5972a95b0e805037aa149.jpg";